export const SYNC_APP_TABS = 'SYNC_APP_TABS';
export const APP_TAB_SET_PARAMS = 'APP_TAB_SET_PARAMS';
